// Current presentation order. Previous sections' media remain in public/slides.
// Title-only sections intentionally have no media until the user supplies it.
// Native video: { type: "video", src, webm, poster, alt }.
export const SLIDES = [
  {
    id: "cover", label: "Welcome", layout: "cover",
    title: "SUNREEF.", subtitle: "Life in Full.",
    media: { type: "video", src: "/slides/hero.mp4", webm: "/slides/hero.webm", poster: "/slides/hero-poster.jpg", alt: "Sunreef yacht cruising on open water" },
  },
  {
    id: "gdanks-shipyard", label: "Gdańsk Shipyard", layout: "shipyard",
    title: "Gdańsk", accent: "Shipyard",
    media: { type: "video", src: "/slides/gdanks-shipyard.mp4", webm: "/slides/gdanks-shipyard.webm", poster: "/slides/gdanks-shipyard-poster.jpg", alt: "Sunreef shipyard in Gdańsk, Poland" },
  },
  {
    id: "uae", label: "UAE Expansion", layout: "shipyard",
    title: "UAE", accent: "Expansion",
    media: { type: "video", src: "/slides/uae-fill.mp4", webm: "/slides/uae-fill.webm", poster: "/slides/uae-fill-poster.jpg", alt: "Sunreef shipyard in Ras Al Khaimah, UAE" },
  },
  {
    id: "ultima-88-virtual-launch", label: "ULTIMA 88 Virtual Launch", layout: "agenda",
    title: "ULTIMA 88", accent: "Virtual Launch",
    media: { type: "video", src: "/slides/ultima-88-virtual.mp4", webm: "/slides/ultima-88-virtual.webm", poster: "/slides/ultima-88-virtual-poster.jpg", alt: "Sunreef ULTIMA 88 virtual launch film", preferMp4: true, preload: "metadata" },
  },
  {
    id: "ultima-88-cannes", label: "ULTIMA 88 Global Premiere in Cannes", layout: "agenda",
    title: "ULTIMA 88", accent: "Global Premiere in Cannes",
    media: { type: "video", src: "/slides/ultima-88-cannes.mp4", webm: "/slides/ultima-88-cannes.webm", poster: "/slides/ultima-88-cannes-poster.jpg", alt: "Sunreef ULTIMA 88 global premiere in Cannes", preferMp4: true, preload: "metadata" },
  },
  {
    id: "brabus", label: "BRABUS ULTIMA 55", layout: "collaboration",
    title: "BRABUS", accent: "ULTIMA 55", smallTitle: true,
    media: { type: "video", src: "/slides/brabus-ultima.mp4", webm: "/slides/brabus-ultima.webm", poster: "/slides/brabus-ultima-poster.jpg", alt: "BRABUS ULTIMA film", preferMp4: true, preload: "metadata" },
  },
  {
    id: "wetra", label: "WETRA Launch",
    title: "WETRA", accent: "Launch",
    media: { type: "video", src: "/slides/wetra-launch.mp4", webm: "/slides/wetra-launch.webm", poster: "/slides/wetra-launch-poster.jpg", alt: "Sunreef WETRA onboard control systems" },
  },
  {
    id: "100-sail-eco", label: "SUNREEF 100 Eco Premiere",
    title: "SUNREEF 100\u00a0Eco", accent: "Premiere",
    // First second is trimmed from the files, so every native loop starts at source 00:01.
    media: { type: "video", src: "/slides/100-eco-premiere.mp4", webm: "/slides/100-eco-premiere.webm", poster: "/slides/100-eco-premiere-poster.jpg", alt: "Sunreef 100 Sail Eco premiere film", preferMp4: true, preload: "metadata" },
  },
  {
    id: "superyachts", label: "Superyachts", layout: "production",
    title: "Superyachts",
    // One full-length sequence: the current 43M film, then the supplied 50M film.
    media: { type: "video", src: "/slides/superyachts-combined.mp4", webm: "/slides/superyachts-combined.webm", poster: "/slides/superyachts-combined-poster.jpg", alt: "Sunreef Superyachts — 43M followed by 50M", preferMp4: true, preload: "metadata" },
  },
  {
    id: "house-of-sunreef", label: "House of Sunreef", layout: "house",
    title: "House of", accent: "Sunreef",
    // Full clips: Nadal → Alonso → Alcaraz → Lewandowski. Mike remains excluded.
    media: { type: "video", src: "/slides/house-of-sunreef.mp4", webm: "/slides/house-of-sunreef.webm", poster: "/slides/house-of-sunreef-poster.jpg", alt: "House of Sunreef — Rafael Nadal, Fernando Alonso, Carlos Alcaraz and Robert Lewandowski", preferMp4: true, preload: "metadata", mobileFocus: [{ from: 0, position: "28%" }, { from: 8.917, position: "68%" }, { from: 11.417, position: "43%" }, { from: 18.917, position: "42%" }, { from: 28.917, position: "52%" }] },
  },
  {
    id: "messi-announcement", label: "House of Sunreef Welcomes Messi", layout: "welcome",
    title: "House of Sunreef", accent: "Welcomes Messi",
    quote: {
      versions: [
        {
          language: "es",
          paragraphs: [
            "Es una alegría sumarme a la familia de Sunreef. La verdad es que tanto a mi familia como a mí nos encanta disfrutar del mar siempre que tenemos la oportunidad.",
            "Los barcos de Sunreef tienen el estilo y las características que me gustan, y son perfectos para lo que busco. Tengo muchas ganas de probar el ULTIMA 88 y empezar a disfrutarlo junto a mi familia.",
          ],
        },
        {
          language: "en",
          paragraphs: [
            "It’s a real pleasure to join the Sunreef family. My family and I have always loved spending time at sea whenever we get the chance.",
            "Sunreef yachts have the style and features I really like, and they’re a perfect fit for what I’m looking for. I’m really looking forward to experiencing the ULTIMA 88 and enjoying it with my family.",
          ],
        },
      ],
      author: "Leo Messi",
    },
    notice: { label: "EXCLUSIVE", text: "PLEASE DO NOT PHOTOGRAPH, POST OR SHARE" },
    media: { type: "image", src: "/slides/messi-welcome.webp", alt: "Lionel Messi seated in a dark suit" },
  },
  {
    id: "closing", label: "Thank you", layout: "closing",
    title: "Thank you", subtitle: "Life in Full.",
  },
];